import type {FC} from 'react';
import {MdClose, MdMode} from 'react-icons/md';
import {cn} from '../../../../../lib/classname';

export const EditButton: FC<{
  editing: boolean;
  editClick: () => void;
  isBgCircle?: boolean;
  disabled?: boolean;
}> = ({editing, editClick, isBgCircle, disabled = false}) => {
  return (
    <button
      type="button"
      className={cn(
        'text-black-3 p-8',
        isBgCircle &&
          'flex items-center justify-center rounded-16 bg-background w-[40px] h-[40px]',
        !isBgCircle && 'rounded-full hover:bg-black-4 hover:text-white',
        'enabled:hover:opacity-60 cursor-pointer',
        'disabled:opacity-50 disabled:cursor-not-allowed',
      )}
      onClick={editClick}
      disabled={disabled}
    >
      {editing ? <MdClose size={20} /> : <MdMode size={20} />}
    </button>
  );
};
